// import { Step4Model } from './../franchise-creation/models/models';

import { FranchiseDetailModel, FranchiseSearchModel, Franchises, CancelFranchiseModel } from '../franchise-creation/models/models';
import { HttpClient, HttpParams } from '@angular/common/http';

import { AppConfigService } from '../shared/providers/config.service';
import { FranchiseAppGlobal } from '../franchise-app-global';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { saveAs } from 'file-saver';

@Injectable()
export class FranchiseService {
    private env;
    constructor(
        public http: HttpClient,
        private config: AppConfigService
    ) {
        this.env = config.getConfig();
    }

    // Get Donor franchises
    GetMyFranchises(searchModel: FranchiseSearchModel): Observable<Franchises> {
        var searchCriteria = JSON.stringify(searchModel);
        let url = this.env.baseUrl + FranchiseAppGlobal.getMyFranchises;
        return this.http.post<Franchises>(url, searchModel);
    }

    // Get Franchise Details
    GetFranchise(franchiseNo: string) {
        let params: HttpParams = new HttpParams().set('franchiseNo', franchiseNo);
        let url = this.env.baseUrl + FranchiseAppGlobal.getFranchisebyNo;
        return this.http.get<FranchiseDetailModel>(url, { params: params });
    }

    //Print franchise certificate 
    PrintFranchiseCertificate(franchiseNo: string) {
        let params: HttpParams = new HttpParams().set('franchiseNo', franchiseNo);
        let url = this.env.baseUrl + FranchiseAppGlobal.getFranchiseCertificate + '?franchiseNo=' + franchiseNo;

        // console.log(url);
        this.http.get(url, { responseType: 'blob' }).subscribe(
            blob => {
                saveAs(blob, 'FranchiseCertificate.pdf' /*, { type: 'text/plain;charset=windows-1252' }*/);
            },
            error => { }
        )
    }

    //Cancel franchise
    CancelFranchise(cancelFranchiseModel: CancelFranchiseModel) {
        // let url = this.env.baseUrl + FranchiseAppGlobal.cancelFranchise + "/" + franchiseId;
        let url = this.env.baseUrl + FranchiseAppGlobal.cancelFranchise;
        // console.log(cancelFranchiseModel);

        return this.http.post(url, cancelFranchiseModel);
    }
    // Get QR-Code details 
    getQrCodeDetails(qrId : string){
        return this.http.get(`${this.env.baseUrl}franchiseQRCode/franchiseInfo?encryptedFranchiseNo=${qrId}`)

    }

}